// ----------------------------------------------------------------------
// <copyright file="Izenda.Export.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
! function () {
  require('share/utils/Izenda.StringUtilities');
  var config = require('config');
  var uiState = require('logic/Izenda.UiState.js');
  var AccountConstants = require('logic/data/Izenda.AccountConstants');
  var AuthUtils = require('share/utils/Izenda.AuthUtils');
  var SecurityManager = require('share/authorization/Izenda.SecurityManager');

  require('share/utils/Izenda.FileDownloader');

  /**
   * Web API data fetcher
   * @constructor
   * @param {string} path - Query url path
   * @param {Object} config - Advanced configuration.
   */
  function Export(path, config) {
    this.path = path;
    this.config = config;
  }

  /**
   * Resolve API url from path
   * @param {type} path
   * @returns {type}
   */
  Export.prototype.resolveUrl = function (path) {
    ensure(path || path !== '', 'Path of url must be provided');
    var root = config.WebApiUrl;
    var safePath = path ? path[0] === '/' ? path.substring(1) : path : '';
    return root.concat(root.slice(-1) !== '/' ? '/'.concat(safePath) : safePath);
  };

  /**
   * Download file using jquery file downloader library
   * @param  {string} method      download method
   * @param  {object} requestData request data
   * @param  {string} path        api path
   * @return {Promise}
   */
  Export.prototype.download = function (method, requestData, successCallBack, failCallBack, checkExportStatus) {
    var url = this.resolveUrl(this.path);
    var securityManager = new SecurityManager();
    var fileSession = String.newGuid();

    Object.assign(
      requestData,
      {
        access_token: securityManager.getAccessToken(),
        current_tenant: uiState.getTenantId(),
        fileSessionKey: fileSession,
        rootPath: config.RootPath
      }
    );

    return $izenda.fileDownload(
      url,
      {
        httpMethod: method,
        data: requestData,
        cookieValue: true,
        cookieName: fileSession,
        successCallback: successCallBack,
        failCallback: failCallBack,
        checkStatus: checkExportStatus
      }
    );
  };

  /**
   * Export file by post method using jquery file downloader plugin
   * @param  {obhect} requesetData  request data
   * @return {Promise}
   */
  Export.prototype.post = function (requesetData, successCallBack, failCallBack, checkExportStatus) {
    return this.download('POST', requesetData, successCallBack, failCallBack, checkExportStatus);
  };

  /**
   * Export file by get method using jquery file downloader plugin
   * @param  {obhect} requesetData  request data
   * @return {Promise}
   */
  Export.prototype.get = function (requesetData, successCallBack) {
    return this.download('GET', requesetData, successCallBack);
  };

  module.exports = function (path, config) {
    return new Export(path, config);
  };
}();



// WEBPACK FOOTER //
// ./ui/share/export/Izenda.Export.js